<template>
  <div class="ic-form__files">
    <hr>
    <IcFormRowWrapper
      id="files"
      name="files"
      :label="$t('label_attachment')"
      :labelWidth="4"
      :controlWidth="8"
    >
      <template slot-scope="{validator}">
        <IcInputFile id="file" v-model="files" @input="$emit('input', $event);" :v="validator" :maxFiles="maxFiles"/>
      </template>
      errr!
    </IcFormRowWrapper>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-8">{{$t('label_max_filesize')}}</div>
    </div>
  </div>
</template>

<script>
import IcFormRowHorizontal from "@/components/ic-common/form/helpers/FormRowHorizontal";
import IcInputFile from "@/components/ic-common/form/controls/InputFile";

export default {
  name: "IcFormContactFiles",
  props: {
    value: {
      type: Array
    },
    maxFiles: {
      type:Number
    }
  },
  data() {
    return {
      files: []
    };
  },
  components: {
    IcFormRowHorizontal,
    IcInputFile
  }
};
</script>

<style>
</style>
